import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default function setCarousel() {
  const productsCarousel = document.querySelectorAll('[data-products-carousel]');

  productsCarousel.forEach((section) => {
    const carousel = section.querySelector('.swiper');
    const pagination = section.querySelector('.swiper-pagination');
    const next = section.querySelector('.swiper-button-next');
    const prev = section.querySelector('.swiper-button-prev');

    if (carousel) {
      const swiper = new Swiper(carousel, {
        modules: [Navigation, Pagination],
        slidesPerView: 2,
        spaceBetween: 8,
        watchOverflow: true,
        speed: 1000,
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 24,
            navigation: {
              nextEl: next,
              prevEl: prev,
            },
          },
          1440: {
            slidesPerView: 5,
            spaceBetween: 24,
            navigation: {
              nextEl: next,
              prevEl: prev,
            },
          },
        },
        pagination: {
          el: pagination,
          type: 'bullets',
          clickable: true,
        },
      });
    }
  });

  function initCountdown() {
    const el = document.querySelector('[data-countdown]');
    if (!el) return;

    const rawDate = el.getAttribute('data-countdown');
    if (!rawDate) return;

    const [datePart, timePart = '00:00:00'] = rawDate.split(' ');
    const [day, month, year] = datePart.split('/').map(Number);
    const [hour = 0, minute = 0, second = 0] = timePart.split(':').map(Number);

    const targetDate = new Date(year, month - 1, day, hour, minute, second).getTime();
    const now = Date.now();

    if (targetDate <= now) {
      el.style.display = 'none';
      return;
    }

    el.innerHTML = `
    <div class="countdown-box">
      <span class="countdown-value" data-hours>00</span>
      <span class="countdown-label">HORAS</span>
    </div>
    <div class="countdown-box">
      <span class="countdown-value" data-minutes>00</span>
      <span class="countdown-label">MIN</span>
    </div>
    <div class="countdown-box">
      <span class="countdown-value" data-seconds>00</span>
      <span class="countdown-label">SEG</span>
    </div>
  `;

    const hoursEl = el.querySelector('[data-hours]');
    const minutesEl = el.querySelector('[data-minutes]');
    const secondsEl = el.querySelector('[data-seconds]');

    function update() {
      const now = Date.now();
      const diff = targetDate - now;

      if (diff <= 0) {
        el.style.display = 'none';
        clearInterval(timer);
        return;
      }

      const totalSeconds = Math.floor(diff / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      hoursEl.textContent = String(hours).padStart(2, '0');
      minutesEl.textContent = String(minutes).padStart(2, '0');
      secondsEl.textContent = String(seconds).padStart(2, '0');
    }

    update();
    const timer = setInterval(update, 1000);
  }

  initCountdown();
}
